module.exports = __webpack_public_path__ + "img/jumbotron-flag.7b6dd6b8.jpg";